import { Badge } from "@/components/ui/badge";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { EmptyState } from "@/pages/CustomerPortal/Financial/component/EmptyState";
import type { CommercialCycle } from "@/lib/api";
import { STATUS_BADGE, formatDateValue } from "./constants";
import { CycleActionButtons } from "./CycleActionButtons";

interface CyclesTableProps {
  cycles: CommercialCycle[];
  onPublish: (year: number) => void;
  onOpen: (year: number) => void;
  onStartClosing: (year: number) => void;
  onClose: (year: number) => void;
  isPublishing: boolean;
  isOpening: boolean;
  isStartingClosing: boolean;
  isClosing: boolean;
}

export function CyclesTable({
  cycles,
  onPublish,
  onOpen,
  onStartClosing,
  onClose,
  isPublishing,
  isOpening,
  isStartingClosing,
  isClosing,
}: CyclesTableProps) {
  if (cycles.length === 0) {
    return (
      <EmptyState
        title="Nenhum ciclo comercial encontrado"
        message="Gere um rascunho a partir de um ciclo existente para começar."
      />
    );
  }

  return (
    <div className="rounded-md border border-border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Ano</TableHead>
            <TableHead>Status</TableHead>
            <TableHead>Publicado em</TableHead>
            <TableHead>Aberto em</TableHead>
            <TableHead>Fechamento iniciado em</TableHead>
            <TableHead>Fechado em</TableHead>
            <TableHead className="text-right">Ações</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {cycles
            .slice()
            .sort((a, b) => a.year - b.year)
            .map((cycle) => {
              const statusInfo = STATUS_BADGE[cycle.status];
              return (
                <TableRow key={cycle.year}>
                  <TableCell className="font-semibold">{cycle.year}</TableCell>
                  <TableCell>
                    <Badge variant={statusInfo.variant}>{statusInfo.label}</Badge>
                  </TableCell>
                  <TableCell>{formatDateValue(cycle.publishedAt)}</TableCell>
                  <TableCell>{formatDateValue(cycle.openedAt)}</TableCell>
                  <TableCell>{formatDateValue(cycle.closingAt)}</TableCell>
                  <TableCell>{formatDateValue(cycle.closedAt)}</TableCell>
                  <TableCell className="text-right">
                    <CycleActionButtons
                      cycle={cycle}
                      onPublish={onPublish}
                      onOpen={onOpen}
                      onStartClosing={onStartClosing}
                      onClose={onClose}
                      isPublishing={isPublishing}
                      isOpening={isOpening}
                      isStartingClosing={isStartingClosing}
                      isClosing={isClosing}
                    />
                  </TableCell>
                </TableRow>
              );
            })}
        </TableBody>
      </Table>
    </div>
  );
}
